/**
 * Video Block — click-to-play for poster mode.
 */
document.querySelectorAll( '.vb-poster-wrap' ).forEach( ( wrap ) => {
	wrap.addEventListener( 'click', () => {
		const src = wrap.dataset.src;
		if ( ! src ) return;

		let autoplaySrc = src;
		if ( src.includes( 'youtube.com' ) || src.includes( 'youtu.be' ) ) {
			autoplaySrc = src + ( src.includes( '?' ) ? '&' : '?' ) + 'autoplay=1&rel=0';
		} else if ( src.includes( 'vimeo.com' ) ) {
			autoplaySrc = src + ( src.includes( '?' ) ? '&' : '?' ) + 'autoplay=1';
		}

		const iframe = document.createElement( 'iframe' );
		iframe.src = autoplaySrc;
		iframe.title = 'Video';
		iframe.frameBorder = '0';
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
		iframe.allowFullscreen = true;
		iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;display:block;';

		wrap.replaceWith( iframe );
	} );
} );
